<template>
  <a-select
    :default-active-first-option="false"
    :filter-option="false"
    :not-found-content="null"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    show-search
    @change="onChange"
    @clear="onClear"
    @search="onSearch"
  >
    <a-select-option v-for="item in options" :key="item.id" :value="item.id">{{
      item.name
    }}</a-select-option>
  </a-select>
</template>

<script lang="ts">
import { computed, defineComponent, watch, onMounted } from "vue";
import { ParticipantsService } from "@/views/labor/participants/participants.service";

export default defineComponent({
  name: "ParticipantsSearchSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
  },
  emit: ["update:value", "change", "clear"],
  setup(props, { emit }) {
    const { data, run } = ParticipantsService.uselistApi();
    const options = computed(() => {
      if (data && data.value?.records) {
        return data.value?.records;
      }
      return [];
    });

    const onSearch = async (name) => {
      await run({ companyName: name, enable: true });
    };
    onMounted(async () => {
      await run({ companyName: "", enable: true });
    });

    const onChange = (value) => {
      emit("update:value", value);
      emit("change", value);
    };

    const onClear = () => {
      emit("update:value", undefined);
      emit("clear", undefined);
    };

    watch(
      () => props.value,
      async (id) => {
        if (id) {
          await run({ ids: [id] });
        } else {
          await run({ companyName: "" });
        }
      },
      { immediate: true }
    );

    return {
      options,
      onSearch,
      onChange,
      onClear,
    };
  },
});
</script>
